import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            吃瓜在线平台功能与内容更新一览，持续为你优化在线观看体验
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          {/* Timeline line */}
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 pl-14">
                {/* Timeline dot */}
                <span className="absolute left-[14px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>

                {/* Date */}
                <span className="text-xs text-foreground-500 whitespace-nowrap pt-0.5 flex-shrink-0 w-24">
                  {item.date}
                </span>

                {/* Text */}
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}